import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IMetaAdsCallbackResponse } from "../../features/Campaigns/interface/metaAds";

interface UseMetaAdsCallbackParams {
  code: string;
  state: string;
  trackingId?: string;
}

export const useMetaAdsCallback = () => {
  return useMutation<IMetaAdsCallbackResponse, Error, UseMetaAdsCallbackParams>({
    mutationFn: (data) => httpService.post<IMetaAdsCallbackResponse>(
      API_CONFIG.path.metaAdsCallback,
      {
        code: data.code,
        state: data.state,
        tracking_id: data.trackingId
      }
    ),
  });
};
